(() => {
  const translations = {
    '84f60e99-ad6f-47e5-8c9b-4bc712c3e894': {
      title: 'Very good quality',
      body: 'Very good quality. Exactly what I needed.'
    },
    '13f576fe-3887-4bfa-9e58-44c528d6e59c': {
      title: 'Arrived in perfect condition',
      body: 'Arrived in perfect condition. My cat sits next to it without moving, completely mesmerized.'
    },
    'db11d202-df5f-471a-b704-a02f77e8cd00': {
      title: 'Arrived intact and easy to assemble',
      body: 'The delivery driver had left the package outside by the door, so I really thought it might be broken... but luckily it arrived completely intact and works well. It was also very easy to put together. Really great, highly recommend!'
    },
    'adf9ab8c-6c68-49d9-85e6-0a8b9a180881': {
      title: 'Small, cute and easy to clean',
      body: 'It is small and cute, and the ceramic feels nice. I am especially very happy with how easy it is to clean. No complicated or hidden corners, and not many parts either. That makes it very easy to keep clean. Very good product.'
    },
    '7a932039-8707-4b34-8068-289ac0c5ffad': {
      title: 'Quiet pump',
      body: 'Arrived safely. The water pump is quiet.'
    },
    'f8450fb3-e06d-4608-a41e-0d4cb5ed4f57': {
      title: '10/10, quiet and easy to clean',
      body: '10/10! Super quiet, easy to clean and hygienic. I am buying another one!'
    },
    '6260bf2b-e6e7-47cf-b5c1-5da353036dc1': {
      title: 'Beautiful, although you can hear the pump a little',
      body: 'It looks very nice. The part on the inside is made of plastic, though. You can hear the water pump a little, but it could be replaced with a quieter one if needed.'
    },
    'd4a07cd1-8a50-469c-ad5e-cbf0b6ec37be': {
      title: 'Ceramic and very quiet',
      body: 'The fountain is ceramic, which I like for my cat. Easy to assemble and install. On the lowest setting you can barely hear anything; on the others, mostly the water. It is supposed to have 3 settings, but I mainly notice 1 gentler and 2 stronger ones. My cat has not tried it yet.'
    },
    'c28e05a2-23f0-4850-8bf6-adbb728555cf': {
      title: 'Well packed and arrived intact',
      body: 'It was packed securely in Styrofoam and luckily arrived intact. The ceramic looks good and it comes with 1 filter. Now I just hope my cat starts using it too :)'
    },
    'f9d92377-9c7f-4ad4-807e-5a556904ec86': {
      title: 'Good quality and quiet',
      body: 'Just received it. Seems like good quality and makes no noise.'
    },
    '1ed93014-ad51-4020-9791-0929958fe9b3': {
      title: 'Arrived intact and easy to maintain',
      body: 'Arrived without damage and works well. Ceramic is nice from a hygiene perspective, and because the filter can be replaced, maintenance seems easy. Thank you.'
    },
    '3690e026-3941-4e04-8a5c-8155ab657d1f': {
      title: 'Good purchase',
      body: 'Very good purchase! Easy to put together and really makes no noise :)'
    },
    '8b32f644-8b12-4d55-a144-5ce0f6d3da23': {
      title: 'Well packed, wrong colour',
      body: 'Arrived well packed and it works. I had ordered all white, though, and did not get exactly the colour I chose.'
    },
    '3e2ac95f-b66a-4b74-b43b-df95af2df6b6': {
      title: 'As advertised',
      body: 'Everything arrived safely, just as advertised.'
    },
    '1a3f7f90-9cd6-4408-8a52-87df2c916455': {
      title: 'Beautiful and my cats drink a lot from it',
      body: 'It really is beautiful, I love it and so do my cats. It seems like they drink much more water than they used to from their plastic bowl. The product itself is great. The delivery was a mess, though, and the box was a bit dented. I think the fountain may be leaking slightly because of that.'
    }
  };

  window.__WN_NAMI_REVIEW_TRANSLATIONS__ = translations;

  const addStyles = () => {
    if (document.getElementById('wn-review-translation-styles')) return;
    const style = document.createElement('style');
    style.id = 'wn-review-translation-styles';
    style.textContent = `
      .wn-review-translation-tools {
        display: flex;
        align-items: center;
        gap: .55rem;
        margin-top: .7rem;
        color: var(--wn-muted, #796b61);
        font-size: 1.05rem;
        line-height: 1.35;
      }
      .wn-review-translation-tools button {
        appearance: none;
        padding: 0;
        border: 0;
        background: transparent;
        color: inherit;
        font: inherit;
        font-weight: 700;
        text-decoration: underline;
        text-underline-offset: .18em;
        cursor: pointer;
      }
      .wn-review-translation-tools button:focus-visible {
        outline: 2px solid currentColor;
        outline-offset: 3px;
        border-radius: 2px;
      }
    `;
    document.head.appendChild(style);
  };

  const setTranslatedBody = (bodyEl, text) => {
    const paragraph = document.createElement('p');
    paragraph.textContent = text;
    bodyEl.replaceChildren(paragraph);
  };

  const localizeCard = (card) => {
    if (!(card instanceof Element) || card.dataset.wnReviewLocalized === 'true') return;

    const reviewId = card.getAttribute('data-review-id');
    const translation = translations[reviewId];
    if (!translation) return;

    const titleEl = card.querySelector('.jdgm-rev__title');
    const bodyEl = card.querySelector('.jdgm-rev__body');
    if (!titleEl || !bodyEl) return;

    const originalTitle = titleEl.textContent.trim();
    const originalBodyHtml = bodyEl.innerHTML;
    let showingOriginal = false;

    titleEl.textContent = translation.title;
    setTranslatedBody(bodyEl, translation.body);
    card.dataset.wnReviewLocalized = 'true';

    const tools = document.createElement('div');
    tools.className = 'wn-review-translation-tools';

    const note = document.createElement('span');
    note.textContent = 'Translated from Dutch';

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.textContent = 'Show original';
    toggle.setAttribute('aria-pressed', 'false');

    toggle.addEventListener('click', () => {
      showingOriginal = !showingOriginal;
      if (showingOriginal) {
        titleEl.textContent = originalTitle;
        bodyEl.innerHTML = originalBodyHtml;
        note.textContent = 'Original Dutch';
        toggle.textContent = 'Show English translation';
        toggle.setAttribute('aria-pressed', 'true');
      } else {
        titleEl.textContent = translation.title;
        setTranslatedBody(bodyEl, translation.body);
        note.textContent = 'Translated from Dutch';
        toggle.textContent = 'Show original';
        toggle.setAttribute('aria-pressed', 'false');
      }
    });

    tools.append(note, toggle);
    bodyEl.insertAdjacentElement('afterend', tools);
  };

  const localizeWithin = (root) => {
    if (!root) return;
    if (root instanceof Element && root.matches('[data-review-id]')) localizeCard(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-review-id]').forEach(localizeCard);
  };

  addStyles();
  localizeWithin(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) localizeWithin(node);
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      localizeWithin(document);
      observer.observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  }
})();
